import { useEffect, useState } from 'react';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { getOrgCode } from '../../helper/utils.helper';
import { getCertificate } from '../../helper/api.helper';
import TopNav from '../../components/top-nav/TopNav';
import Footer from '../../components/Footer';
import Loader from '../../components/loader/Loader';
import { getDate } from '../dashboard/history/history.service';
import DisplayPdf from '../shared/DisplayPdf';

const Certificate = () => {
  const { certificateId } = useParams();
  const navigate = useNavigate();
  const [certificateData, setCertificateData] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchCertificate = async () => {
    setLoading(true);
    if (!certificateId) return;
    const orgCode = getOrgCode();
    await getCertificate(orgCode, certificateId)
      .then((res) => res.json())
      .then((res) => {
        if (res.status === 'success') {
          setCertificateData(res.data);
          setLoading(false);
        } else {
          setLoading(false);
          navigate('/404');
        }
      })
      .catch((err) => {
        setLoading(false);
        setError(err?.message);
      });
  };

  useEffect(() => {
    fetchCertificate();
  }, [certificateId]);

  return (
    <>
      <TopNav />
      <div className="certificate-wrapper">
        {isLoading ? <Loader /> : null}
        {certificateData ? (
          <>
            <div className="details-outer-div">
              <div className="details-inner-div">
                <div className="flex-container align-center margin-bottom--md">
                  <VerifiedOutlinedIcon style={{ fontSize: '75px', color: '#00C853' }} />
                  <h1 className="heading">
                    <i>Verification Details:</i>
                  </h1>
                </div>
                <p className="detail">
                  Certificate Holder: <span>{certificateData?.certificateHolder}</span>
                </p>
                <p className="detail">
                  Course Title: <span>{certificateData?.courseTitle}</span>
                </p>
                <p className="detail">
                  Course ID: <span>{certificateData?.courseId}</span>
                </p>
                <p className="detail">
                  Organisation: <span>{certificateData?.organisation}</span>
                </p>
                <p className="detail">
                  Organisation ID: <span>{certificateData?.organisationId}</span>
                </p>
                <p className="detail">
                  Certificate Issue Date: <span>{getDate(certificateData?.issueDate)}</span>
                </p>
                <p className="detail">
                  Certificate ID: <span>{certificateData?.certificateId}</span>
                </p>
                <p className="margin-top--lg">
                  Ensure the details above match the certificate, confirm the URL is legitimate and
                  corresponds to our official website.
                </p>
              </div>
            </div>
            {certificateData?.certificateUrl ? (
              <div className="certificate-div">
                <DisplayPdf resourceUrl={certificateData?.certificateUrl} />
              </div>
            ) : null}
          </>
        ) : error ? (
          <p className="margin-top--md" style={{ marginLeft: '20px' }}>
            Unable to load certificate. {error}
          </p>
        ) : null}
      </div>
      <Footer />

      <style jsx>
        {`
          .certificate-wrapper {
            min-height: 90vh;
          }
          .details-outer-div {
            background-color: #effff2;
          }
          .details-inner-div {
            max-width: 950px;
            margin: auto;
            padding: 20px 20px;
          }
          .heading {
            margin: 5px 0px 0px 10px;
            font-size: 3rem;
            font-weight: 500;
          }
          .detail {
            margin-top: 2px;
          }
          .detail span {
            font-weight: 600;
          }
          .certificate-div {
            margin: auto;
            max-width: 950px;
            padding-bottom: 32px;
          }
          @media only screen and (max-width: 600px) {
            .heading {
              font-size: 2rem;
            }
          }
        `}
      </style>
    </>
  );
};

export default Certificate;
